import { httpGetRoles } from '@iconik-io/iconik-api/src/services/users';

import type { AppDispatch } from '../../store/types';
import { setAllRoles } from './slice';

export function getRoles() {
  return (dispatch: AppDispatch) =>
    dispatch(httpGetRoles()).then(({ body }) => {
      dispatch(setAllRoles(body));
    });
}
